import React, { Component } from "react";

export default class ProjectsImg extends Component {
  render() {
    const { theme } = this.props;

    return (
      <svg
        width="400"
        height="260"
        viewBox="0 0 400 260"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background glow */}
        <defs>
          <linearGradient id="projects-bg" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0" stopColor={theme.imageHighlight} stopOpacity="0.15" />
            <stop offset="1" stopColor={theme.imageHighlight} stopOpacity="0.35" />
          </linearGradient>
        </defs>

        <rect
          x="10"
          y="20"
          width="380"
          height="220"
          rx="24"
          fill="url(#projects-bg)"
        />

        {/* Top bar */}
        <rect
          x="20"
          y="30"
          width="360"
          height="26"
          rx="13"
          fill={theme.text}
          opacity="0.12"
        />
        <circle cx="40" cy="43" r="4" fill="#ff5f57" />
        <circle cx="55" cy="43" r="4" fill="#febc2e" />
        <circle cx="70" cy="43" r="4" fill="#28c840" />

        {/* Three project cards */}
        {[
          { x: 35, color: theme.imageHighlight },
          { x: 150, color: theme.text },
          { x: 265, color: theme.secondaryText || theme.text },
        ].map((card, index) => (
          <g key={index} transform={`translate(${card.x}, 80)`}>
            <rect
              width="100"
              height="130"
              rx="16"
              fill="#ffffff"
              opacity="0.95"
            />
            <rect
              x="10"
              y="14"
              width="80"
              height="18"
              rx="9"
              fill={card.color}
              opacity="0.85"
            />
            <rect
              x="10"
              y="44"
              width="80"
              height="6"
              rx="3"
              fill={theme.text}
              opacity="0.25"
            />
            <rect
              x="10"
              y="58"
              width="70"
              height="6"
              rx="3"
              fill={theme.text}
              opacity="0.18"
            />
            <rect
              x="10"
              y="72"
              width="60"
              height="6"
              rx="3"
              fill={theme.text}
              opacity="0.12"
            />
            <rect
              x="10"
              y="96"
              width="50"
              height="20"
              rx="10"
              fill={card.color}
              opacity="0.9"
            />
          </g>
        ))}
      </svg>
    );
  }
}
